import { AppId, createPageRoute, URL_PREFIX } from '@lumapps/router';

export const agentLibraryRoute = createPageRoute({
    slug: `${URL_PREFIX}/agent-library`,
    appId: AppId.frontOffice,
});
